import { Duration } from 'date-fns'
import { Box, Text, useTheme } from 'native-base'
import React from 'react'
import { Platform } from 'react-native'

import { CountdownCircularProgress } from '../CountdownCircularProgress'

function DurationText({ duration }: { duration: Duration }) {
  const out = []
  out.push(`${duration.minutes}`.padStart(2, '0'))
  out.push(`${duration.seconds}`.padStart(2, '0'))
  return <>{out.join(':')}</>
}

const textProps =
  Platform.OS === 'web' ? { top: 0, mt: 1 } : { top: '50%', style: { transform: [{ translateY: -12 }] } }

export function Timer({ progress, duration }: { progress: number; duration: Duration }) {
  const theme = useTheme()

  return (
    <Box position="relative" display="flex" flexDirection="row" alignItems="center" justifyContent="center">
      <CountdownCircularProgress progress={progress} color={theme.colors.primary['500']} />
      <Text
        fontSize="lg"
        color="neutral.900"
        fontWeight="700"
        position="absolute"
        right="0"
        left="0"
        bottom="0"
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        {...textProps}
      >
        <DurationText duration={duration} />
      </Text>
    </Box>
  )
}
